'use client';

import { useTranslations } from 'next-intl';

export default function HeaderBanner() {
  const t = useTranslations('headerBanner');
  
  return (
    <div className="w-screen fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-purple-100 via-blue-100 to-purple-100 border-b border-purple-200 py-2 px-4 hidden lg:block">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm">
        <svg width="80" height="32" viewBox="0 0 80 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8L13.2 12L17.2 13.2L13.2 14.4L12 18.4L10.8 14.4L6.8 13.2L10.8 12L12 8Z" fill="white" opacity="0.9"/>
          <path d="M28 4L30 10L36 12L30 14L28 20L26 14L20 12L26 10L28 4Z" fill="white" opacity="0.7"/>
          <path d="M44 10L45 13L48 14L45 15L44 18L43 15L40 14L43 13L44 10Z" fill="white" opacity="0.85"/>
          <path d="M60 6L61.5 10.5L66 12L61.5 13.5L60 18L58.5 13.5L54 12L58.5 10.5L60 6Z" fill="white" opacity="0.75"/>
          <path d="M74 14L75 16.5L77.5 17.5L75 18.5L74 21L73 18.5L70.5 17.5L73 16.5L74 14Z" fill="white" opacity="0.8"/>
        </svg>
        <span className="bg-[linear-gradient(83deg,#5B02FF_14.86%,#8F36FF_98.61%)] bg-clip-text text-transparent font-semibold">{t('new')}</span>
        <span className="text-purple-600">•</span>
        <span className="bg-[linear-gradient(83deg,#5B02FF_14.86%,#8F36FF_98.61%)] bg-clip-text text-transparent font-semibold">{t('introducing')}</span>
        <span className="text-purple-600">•</span>
        <span className="bg-white px-3 py-1 rounded-lg shadow-sm">
          <span className="bg-[linear-gradient(90deg,#B71BFF_0%,#5B02FF_38.94%,#8F36FF_100%)] bg-clip-text text-transparent font-bold">{t('jobbiAI')}</span>
        </span>
        <span className="text-purple-600">•</span>
        <span className="bg-[linear-gradient(264deg,#5B02FF_19.82%,#8F36FF_91.74%)] bg-clip-text text-transparent font-semibold">{t('tagline')}</span>
        <svg width="80" height="32" viewBox="0 0 80 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 14L11 16.5L13.5 17.5L11 18.5L10 21L9 18.5L6.5 17.5L9 16.5L10 14Z" fill="white" opacity="0.8"/>
          <path d="M24 6L25.5 10.5L30 12L25.5 13.5L24 18L22.5 13.5L18 12L22.5 10.5L24 6Z" fill="white" opacity="0.75"/>
          <path d="M40 10L41 13L44 14L41 15L40 18L39 15L36 14L39 13L40 10Z" fill="white" opacity="0.85"/>
          <path d="M56 4L58 10L64 12L58 14L56 20L54 14L48 12L54 10L56 4Z" fill="white" opacity="0.7"/>
          <path d="M72 8L73.2 12L77.2 13.2L73.2 14.4L72 18.4L70.8 14.4L66.8 13.2L70.8 12L72 8Z" fill="white" opacity="0.9"/>
        </svg>
      </div>
    </div>
  );
}
